import { ProductDiscountsApplied } from "../../redux_store/cart/models";
import { ClientTokenReponse } from "../../services/api/checkout/model";
import { BasketItem, Surcharge } from "../../services/api/order/model";
import { StoresTimeZone } from "../../services/api/store/model";
import { ErrorResponse } from "../error/models";
import { CollectionType } from "../order/models";

export enum PaymentType {
  BRAINTREE = "BRAINTREE",
  COUPON = "COUPON",
  GYGDOLLAR = "GYGDOLLAR",
  CASH = "CASH",
  GIFTCARD = "GIFTCARD",
}

export enum OrderFulfilmentStatusType {
  CREATED = "CREATED",
  INPROGRESS = "INPROGRESS",
  VALIDATED = "Validated",
  RECEIVED_AT_SITE = "Received at Site",
  SENT_TO_KITCHEN = "Sent to kitchen",
  SENT_TO_SITE = "Sent to site",
  FINALISED = "Finalised",
  CANCELLED = "Cancelled",
  FAILED = "FAILED",
}

export enum OrderFinalisationStatusType {
  ABANDONED = "ABANDONED",
  COMPLETED = "COMPLETED",
  CREATED = "CREATED",
  INPROGRESS = "INPROGRESS",
  FAILED = "FAILED",
  RECEIVED = "RECEIVED",
}

export interface CheckoutState {
  error?: ErrorResponse;
  clientTokenResponse: ClientTokenReponse;
  loading: boolean;
  paymentResponse: CheckoutResponse | null;
  paymentSuccess: boolean;
  getClientTokenLoading: boolean;
  isSavePayment: boolean;
  hasUnexpectedError: boolean;
}

export interface OrderCheckoutResponse {
  basket: CheckoutBasket;
  errors: [];
  channelId: number;
  orderTimes: CheckoutOrderTimes[];
  orderNumber: string;
  timeZoneInfo: StoresTimeZone;
  orderId: string;
  pickupTime: string;
  activeOrderUntil: string;
  timeSubmitted: string;
  tableNumber: string | null;
  orderFinalisationStatus: OrderFinalisationStatusType;
  orderFulfilmentStatus: OrderFulfilmentStatusType;
  orderProgressStatus: OrderProgressStatus;
}

export interface CheckoutBasket {
  salesTax: number;
  taxRate: number;
  totalExcl: number;
  totalIncl: number;
  totalBeforeDiscount: number;
  basketItems: CheckoutItems[] | BasketItem[];
  storeInvalidProducts: CheckoutItems[];
  discountAmount?: number;
  surcharges: Surcharge[];
  basketValue: number;
  total: number;
  subtotal: number;
}

export interface CheckoutItems {
  id: number;
  name: string;
  price: number;
  quantity: number;
  unitPrice: number;
  addModifiers?: CheckoutItems[];
  extraModifiers?: CheckoutItems[];
  removeModifiers?: CheckoutItems[];
  addFillings?: CheckoutItems[];
  parts?: CheckoutItems[];
  productDiscountsApplied?: ProductDiscountsApplied[];
}

export interface CheckoutOrderTimes {
  date: string;
  timeSlots: number[];
}

export interface PaymentCheckoutResponse {
  type: PaymentType;
  amount: number;
}

export interface Address {
  building: string;
  streetAddress: string;
  city: string;
  state: string;
  postcode: string;
  latitude: number;
  longitude: number;
}

export interface StoreCheckoutResponse {
  id: string;
  name: string;
  phoneNumber: string;
  address: Address;
  timezoneInfo: StoresTimeZone;
}

export interface OrderLoyalty {
  actualDollarsBalance: number;
  actualPointsBalance: number;
  cardNumber: string;
  loyaltyRewardAmount: number;
  loyaltyRewardConversionLimit: number;
  accruedPoints: number;
  convertedDollars: number;
  afterCheckoutDollarsBalance: number;
  afterCheckoutPointsBalance: number;
}

export interface CheckoutResponse {
  loyalty: OrderLoyalty;
  order: OrderCheckoutResponse;
  orderCollectionType: CollectionType;
  payment: PaymentCheckoutResponse[];
  store: StoreCheckoutResponse;
}

export interface RecentAndCurrentOrders {
  recentOrders: CheckoutResponse[];
  currentOrders: CheckoutResponse[];
}

export interface PaymentPayload {
  id: string;
  customer: Customer;
  addCutlery: boolean;
  payment: Payment;
}

export interface Customer {
  firstName: string;
  lastName: string;
  emailAddress: string;
  phoneNumber?: string;
}

export interface Payment {
  braintree?: Braintree;
  gygDollar?: GYGdollarPayment;
  coupon?: {
    code: string;
  };
}

export interface GYGdollarPayment {
  cardNumber: string;
  amount: number;
}

export interface Braintree {
  nonce: string;
  amount: string;
  paymentToken: string;
  checkoutType: number;
  bTAFT: string;
  storeCard: boolean;
}

export enum OrderProgressEnum {
  ABANDONED = "ABANDONED",
  COMPLETED = "COMPLETED",
  CREATED = "CREATED",
  INPROGRESS = "INPROGRESS",
  FAILED = "FAILED",
  RECEIVED = "RECEIVED",
}

export interface OrderProgressStatus {
  orderProgressCode: OrderProgressEnum;
  orderProgressDisplayColour: string;
  orderProgressDisplayName: string;
}

export enum OrderFailType {
  TIMEOUT = "TIMEOUT",
  FAILED = "FAILED",
  INPROGRESS = "INPROGRESS",
}

export interface OrderFailModalProps {
  title: string;
  message: string;
  buttonName: string;
  buttonAction: () => void;
}
